import { render, staticRenderFns } from "./groupBuyingAdminView2.vue?vue&type=template&id=8f947f4c&"
import script from "./groupBuyingAdminView2.vue?vue&type=script&lang=js&"
export * from "./groupBuyingAdminView2.vue?vue&type=script&lang=js&"
import style0 from "./groupBuyingAdminView2.vue?vue&type=style&index=0&id=8f947f4c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports